import { extend } from 'vee-validate'
import { confirmed } from 'vee-validate/dist/rules'

// Confirmed rule
extend('confirmed', {
  ...confirmed,
  message: 'Potwierdzenie hasła nie zgadza się'
})
